import {numberRange} from './utilities';

const categories =  numberRange(2016, 2020).reverse();

export const figure25 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            stacking: 'normal',
        }
    },
    exporting: {
        enabled: false
    },
    xAxis: [{
        tickWidth: 0,
        labels: {
            groupedOptions: [{
                        style: {
                            transform: 'unset'
                        },
                  }],
            style: {
                transform: 'translateX(11px)'
            },
            align: 'right'
        },
        categories: [
            { name: "Países menos<br />adelantados (PMA)", categories: categories },
            { name: "Países en desarrollo<br />sin litoral (PDL)", categories: categories },
            { name: "África subsahariana", categories: categories },
            { name: "Asia occidental y<br />África septentrional", categories: categories },
            { name: "Asia oriental y<br />Asia sudoriental", categories: categories },
            { name: "Asia central y<br />Asia meridional", categories: categories },
            { name: "América Latina y<br />el Caribe", categories: categories },
            { name: "América del Norte y<br />Europa", categories: categories },
            { name: "Mundo", categories: categories } 
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
    }],
    yAxis: [{
        labels: {
            format: '{value}%',
            //format: '{value}',
            style: {
              fontWeight: 'normal',
              color: '#999999',
              fontSize: '12px'
            },
          },
        gridLineWidth: 2,
        floor: 0,
        ceiling: 70,
        tickInterval: 10,
        title: {
            text: null
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        valueSuffix: '%',
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    series: [{
        name: 'Proporción de países por región afectados por precios altos o moderadamente altos de los alimentos',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
    
        },
        data: [ 
            { y: 34, color: "#70ad47" },
            { y: 12, color: "#5b9bd5" },
            { y: 2, color: "#5b9bd5" },
            { y: 10, color: "#5b9bd5" },
            { y: 17, color: "#5b9bd5" },
            { y: 54, color: "#70ad47" },
            { y: 25, color: "#5b9bd5" },
            { y: 7, color: "#5b9bd5" },
            { y: 21, color: "#5b9bd5" },
            { y: 18, color: "#5b9bd5" },
            { y: 39, color: "#70ad47" },
            { y: 9, color: "#5b9bd5" },
            { y: 5, color: "#5b9bd5" },
            { y: 9, color: "#5b9bd5" },
            { y: 23, color: "#5b9bd5" },
            { y: 43, color: "#70ad47" },
            { y: 22, color: "#5b9bd5" },
            { y: 9, color: "#5b9bd5" },
            { y: 22, color: "#5b9bd5" },
            { y: 0, color: "#5b9bd5" },
            { y: 33, color: "#70ad47" },
            { y: 13, color: "#5b9bd5" },
            { y: 7, color: "#5b9bd5" },
            { y: 7, color: "#5b9bd5" },
            { y: 13, color: "#5b9bd5" },
            { y: 67, color: "#70ad47" },
            { y: 17, color: "#5b9bd5" },
            { y: 17, color: "#5b9bd5" },
            { y: 25, color: "#5b9bd5" },
            { y: 0, color: "#5b9bd5" },
            { y: 47, color: "#70ad47" },
            { y: 16, color: "#5b9bd5" },
            { y: 5, color: "#5b9bd5" },
            { y: 3, color: "#5b9bd5" },
            { y: 8, color: "#5b9bd5" },
            { y: 56, color: "#70ad47" },
            { y: 16, color: "#5b9bd5" },
            { y: 2, color: "#5b9bd5" },
            { y: 22, color: "#5b9bd5" },
            { y: 13, color: "#5b9bd5" },
            { y: 47, color: "#70ad47" },
            { y: 16, color: "#5b9bd5" },
            { y: 5, color: "#5b9bd5" },
            { y: 14, color: "#5b9bd5" },
            { y: 14, color: "#5b9bd5" }
        ]
      }]
}
